import React, { useEffect } from 'react'

// Auto-inject luc build: netlify.toml set REACT_APP_BUILD_TIME = "HH:MM, D/M" (gio VN).
// REACT_APP_VERSION = full version (YYYYMMDD-HHmm-sha) -> de trong tooltip.
const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || 'dev'
const VERSION = process.env.REACT_APP_VERSION || 'dev'

// Badge goc PHAI TREN. pointer-events:none -> khong chan nut logout/header ben duoi.
// Nhiều người mở app sẵn trên điện thoại hàng ngày không tắt → vẫn chạy JS cũ sau deploy (15/10/2026 anh Bình hỏi "sao phải refresh").
// Mỗi lần quay lại app (visibilitychange) hoặc 10 phút/lần: xin index.html mới, tên main.<hash>.js khác bản đang chạy → tự tải lại.
// Không tải lại khi đang gõ ô nhập hoặc đang mở form (z-[70]) để không mất dữ liệu đang điền.
// Không dựa vào REACT_APP_VERSION (prod GitLab không set → badge vẫn 'dev'); dev server dùng bundle.js không hash → hienTai rỗng → tự bỏ qua.
const useTuCapNhat = () => {
  useEffect(() => {
    const hienTai = [...document.scripts].map((x) => x.src).find((x) => /\/static\/js\/main\.[0-9a-f]+\.js/.test(x))
    if (!hienTai) return undefined
    let dangKiem = false
    const kiem = async () => {
      if (dangKiem || document.visibilityState !== 'visible') return
      dangKiem = true
      try {
        const html = await (await fetch(`/index.html?_=${Date.now()}`, { cache: 'no-store' })).text()
        const moi = (html.match(/\/static\/js\/main\.[0-9a-f]+\.js/) || [])[0]
        const banRon = document.querySelector('input:focus, textarea:focus, [class*="z-[70]"]')
        if (moi && !hienTai.endsWith(moi) && !banRon) window.location.reload()
      } catch { /* mất mạng → lần sau */ }
      dangKiem = false
    }
    document.addEventListener('visibilitychange', kiem)
    const t = setInterval(kiem, 10 * 60 * 1000)
    return () => { document.removeEventListener('visibilitychange', kiem); clearInterval(t) }
  }, [])
}

const VersionBadge = () => {
  useTuCapNhat()
  return (
  <div
    title={`Build ${VERSION}`}
    style={{
      position: 'fixed',
      top: 3,
      right: 6,
      zIndex: 9999,
      padding: '2px 6px',
      fontSize: 10,
      fontFamily: 'ui-monospace, monospace',
      background: 'rgba(0,0,0,0.45)',
      color: '#fff',
      borderRadius: 4,
      pointerEvents: 'none',
      userSelect: 'none',
      whiteSpace: 'nowrap',
    }}
  >
    {BUILD_TIME}
  </div>
  )
}

export default VersionBadge
